<div class="mat-elevation-z8">
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="name" sticky>
                <th mat-header-cell *matHeaderCellDef> Fields </th>
                <td mat-cell *matCellDef="let element" style="text-transform: capitalize;"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="hideshow">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="isChangeLimitAccessToggleHide($event)" class="switch-input"></mat-checkbox>
                    Show In Form
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox class="example-margin primary" (change)="hideshowChange(element)"
                        [(ngModel)]="element.hideshow"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="show_in_card">
                <th mat-header-cell *matHeaderCellDef>
                    Show In ID-Card
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox class="example-margin primary" [(ngModel)]="element.show_in_card"
                        (change)="onShowcardChange($event)" [disabled]="!element.hideshow"
                        *ngIf="element.name !== 'image' && element.name !== 'id_proof'  && element.name !== 'payment_image'; else dash"></mat-checkbox>
                    <ng-template #dash>
                        Not For Card
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="required">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="isChangeLimitAccessToggle($event)" class="switch-input"></mat-checkbox>
                    Required
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox class="example-margin primary" [(ngModel)]="element.required"
                        [disabled]="!element.hideshow"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>Label</th>
                <td mat-cell *matCellDef="let element">
                    <input type="text" style="width: auto;" class="form-control" [(ngModel)]="element.label">
                </td>
            </ng-container>

            <ng-container matColumnDef="icard_label">
                <th mat-header-cell *matHeaderCellDef>I-card Label</th>
                <td mat-cell *matCellDef="let element">
                    <input type="text" style="width: auto;" class="form-control" [(ngModel)]="element.icard_label">
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">
                    <select class="form-select" [(ngModel)]="element.type"
                        *ngIf="element.name !== 'image' && element.name !== 'id_proof'  && element.name !== 'payment_ss' && element.name !== 'tic_category'; else dash">
                        <option value="">Open this select type</option>
                        <option value="text">Text</option>
                        <option value="number">Number</option>
                        <option value="select">Dropdown</option>
                        <option value="radio">Radio Button</option>
                        <option value="checkbox">Check Box</option>
                    </select>
                    <div *ngIf="element.hideshow && !element.type &&  element.name !=='image' && element.name
                        !=='id_proof' && element.name !=='payment_ss' && element.name !=='tic_category'"
                        class="text-danger">
                        Please select a type for this field.
                    </div>
                    <ng-template #dash>
                        <select class="form-select" disabled>
                            <option selected>Disable For {{element.label}}</option>
                        </select>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>Value</th>
                <td mat-cell *matCellDef="let element">
                    <input
                        *ngIf="element.hideshow && element.type == 'select' || element.hideshow && element.type =='radio' || element.hideshow && element.type == 'checkbox'"
                        autocomplete="off" type="text" style="width: auto;" class="form-control"
                        placeholder="option 1, option 2 , etc" [(ngModel)]="element.value">
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>

    <!-- <div class="d-flex justify-content-center p-3">
        <button type="submit" mat-raised-button color="primary" (click)="Submit()">Save Setting</button>
    </div> -->
</div>
<div class="header_second">
    <button mat-raised-button style="background: green;color: white;margin-right: 10px;"
        (click)="Submit()"><mat-icon>save</mat-icon>Save</button>
</div>